import { Link } from "react-router-dom";
import React, { Component } from "react";
import {
  Button,
  Card as Cd,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
import { Storage } from "aws-amplify";
import Card from "../components/Card/Card.jsx";
import CardHeader from "../components/Card/CardHeader.jsx";
import CardBody from "../components/Card/CardBody.jsx";
import GridContainer from "../components/Grid/GridContainer.jsx";
import GridItem from "../components/Grid/GridItem.jsx";
import CardAvatar from "../components/Card/CardAvatar.jsx";
import imgPlaceholder from "../assets/img/person-placeholder.jpg";
import Icon from "@material-ui/core/Icon";
import Switch from "@material-ui/core/Switch";
import { spinnerService } from "@chevtek/react-spinners";

import Chip from "@material-ui/core/Chip";
import withStyles from "@material-ui/core/styles/withStyles";
import gql from "graphql-tag";
import { getInspector } from "../graphql/queries";
import { connect } from "react-redux";
import { styles } from "../assets/css/styles";
import Avatar from "@material-ui/core/Avatar";
import * as actionTypes from "../redux/actions";

var self = null;
Storage.configure({
  AWSS3: {
    bucket: "calbitwebappuploadbucket1254-dev", //Your bucket name;
    region: "us-east-2" //Specify the region your bucket was created in;
  }
});
class InspectorDetails extends Component {
  constructor(props) {
    super(props);
    self = this;
    this.state = {
      name: "",
      email: "",
      password: "",
      cPassword: "",
      address: "",
      city: "",
      st: "",
      phoneNum: "",
      date: "",
      skills: [],
      qualifications: [],
      experiences: [],
      inspectorType: [],
      deletedInspectorTypes: [],
      iamMechanic: false,
      iamInspector: false,
      picture: imgPlaceholder,
      isPicChanged: false,
      rawPicture: {},
      uploadedPicKey: ""
    };
  }
  async componentDidMount() {
    spinnerService.show("mySpinner");
    const { client, user, profile } = this.props;
    let obj = {};
    let isFetched = false;
    if (profile === undefined || profile === "" || profile === null) {
      const inspector = await client.query({
        query: gql(getInspector),
        fetchPolicy: `network-only`,
        variables: { id: user.username }
      });
      obj = inspector.data.getInspector;
      isFetched = true;
    } else {
      obj = profile;
    }
    this.setState({
      name: obj.name,
      email: obj.email,
      password: "",
      cPassword: "",
      address: obj.homeAddress,
      city: obj.city,
      st: obj.state,
      phoneNum: obj.phoneNo,
      date: obj.registrationDate,
      skills: obj.skills,
      qualifications: obj.qualifications,
      experiences: obj.employmentHistory,
      inspectorType: obj.inspectorType
    });
    let data = { ...obj };
    if (obj.pictureObj === undefined || obj.pictureObj === null) {
      let pic = obj.picture;

      pic !== null &&
        pic !== "" &&
        Storage.get(pic.key)
          .then(picture => {
            this.setState({ picture });
            data.pictureObj = picture;
          })
          .catch(err => {});
    } else this.setState({ picture: obj.pictureObj });
    spinnerService.hide("mySpinner");
    isFetched && this.props.storeProfile(data);
  }

  downloadFile = async key => {
    Storage.get(key)
      .then(result => {
        window.open(result);
      })
      .catch(err => {});
  };
  cancelForm = e => {
    //this.props.location.loadData();
    this.props.history.push("/user/edit");
  };
  onInputChange = event => {};
  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={8}>
          <Row className="justify-content-center">
            <Col lg="12">
              <Card>
                <CardHeader color="primary">
                  <h4 className={classes.cardTitleWhite}>Profile View</h4>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={this.handleSubmit} role="form">
                    <div>
                      <Row form style={{ marginTop: "20px" }}>
                        <Col md={6}>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="name"
                                onChange={this.onInputChange}
                                placeholder="Name"
                                type="text"
                                value={this.state.name}
                                disabled
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col md={6}>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="email"
                                onChange={this.onInputChange}
                                placeholder="Email"
                                type="email"
                                disabled
                                value={this.state.email}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row form>
                        <Col md={12}>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="address"
                                onChange={this.onInputChange}
                                placeholder="Address"
                                type="text"
                                value={this.state.address}
                                disabled
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row form>
                        <Col md={6}>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="city"
                                onChange={this.onInputChange}
                                placeholder="City"
                                type="text"
                                value={this.state.city}
                                disabled
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="st"
                                onChange={this.onInputChange}
                                placeholder="State"
                                type="text"
                                value={this.state.st}
                                disabled
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row form>
                        <Col md={6}>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="phoneNum"
                                onChange={this.onInputChange}
                                placeholder=" Phone No"
                                type="tel"
                                disabled
                                value={this.state.phoneNum}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="date"
                                placeholder="Inspection Since"
                                type="text"
                                onChange={this.onInputChange}
                                value={this.state.date}
                                disabled
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <Cd style={{ marginTop: "20px" }}>
                      <CardHeader style={{ backgroundColor: "#F2F2F2" }}>
                        <h4>Employment History</h4>
                      </CardHeader>
                      <CardBody>
                        {this.state.experiences !== null &&
                          this.state.experiences.length !== 0 &&
                          this.state.experiences.map((item, key) => {
                            return (
                              <div>
                                <h5 style={{ color: "black" }}>
                                  {item.jobTitle}
                                </h5>
                                <div className="row">
                                  <div className="col-4">
                                    <p>Company:{" " + item.company}</p>
                                  </div>
                                </div>
                                <hr />
                              </div>
                            );
                          }, this)}
                      </CardBody>
                    </Cd>
                    <Cd style={{ marginTop: "20px" }}>
                      <CardHeader style={{ backgroundColor: "#F2F2F2" }}>
                        <h4>Qualifications</h4>
                      </CardHeader>
                      <CardBody>
                        {this.state.qualifications !== null &&
                          this.state.qualifications.length !== 0 &&
                          this.state.qualifications.map((item, key) => {
                            return (
                              <div>
                                <div className="row">
                                  <div className="col-4">
                                    <h5>{item.title}</h5>
                                  </div>
                                  <div className="col-6">
                                    <p>
                                      {item.attachment !== null ? (
                                        <p className="fancy-a">
                                          <a
                                            href="#"
                                            style={{ marginLeft: 10 }}
                                            onClick={() =>
                                              this.downloadFile(
                                                item.attachment.key
                                              )
                                            }
                                          >
                                            Download file
                                          </a>
                                        </p>
                                      ) : (
                                        <p>No File Uploaded</p>
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <hr />
                              </div>
                            );
                          }, this)}
                      </CardBody>
                    </Cd>
                    <Cd style={{ marginTop: "20px" }}>
                      <CardHeader style={{ backgroundColor: "#F2F2F2" }}>
                        <h4>Skills</h4>
                      </CardHeader>
                      <CardBody>
                        {this.state.skills !== null &&
                          this.state.skills.length !== 0 &&
                          this.state.skills.map((item, key) => {
                            return (
                              <Chip
                                key={key}
                                label={item}
                                style={{ margin: 5 }}
                              />
                            );
                          }, this)}
                      </CardBody>
                    </Cd>
                    <Cd style={{ marginTop: "10px", fontSize: "large" }}>
                      <CardBody>
                        You are registered as
                        {this.state.inspectorType !== null &&
                          this.state.inspectorType.length !== 0 &&
                          this.state.inspectorType.map((item, key) => {
                            return (
                              <Chip
                                key={key}
                                label={item}
                                style={{ margin: 5 }}
                              />
                            );
                          }, this)}
                      </CardBody>
                    </Cd>
                    <Row lg="12" className="px-3 ">
                      <Col></Col>
                      <Col>
                        <Button
                          className=" btn-lg btn-block mt-2"
                          color="primary"
                          onClick={this.cancelForm}
                        >
                          Edit Profile
                        </Button>
                      </Col>
                      <Col></Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card profile>
            <div>
              <CardAvatar profile style={{ width: 250, height: 250 }}>
                <img src={this.state.picture} alt="..." />
              </CardAvatar>
            </div>
            <CardBody profile>
              <input
                id="insp-pic"
                onChange={e => {
                  this.setState({
                    picture: URL.createObjectURL(e.target.files[0]),
                    rawPicture: e.target.files[0],
                    isPicChanged: true
                  });
                }}
                style={{ display: "none" }}
                type="file"
              />
              <h6 className={classes.cardCategory}>
                {this.state.company} Your Subscriptions
              </h6>
              <Cd style={{ marginTop: "10px", fontWeight: "bold" }}>
                <CardBody>
                  {this.state.inspectorType !== null &&
                    this.state.inspectorType.length !== 0 &&
                    this.state.inspectorType.map((item, key) => {
                      return (
                        <Chip key={key} label={item} style={{ margin: 5 }} />
                      );
                    }, this)}{" "}
                </CardBody>
              </Cd>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    profile: state.config.profile
  };
};
const mapDispatchToProps = dispatch => {
  return {
    // addCounter: (id) => dispatch({type:actionTypes.Add_Counter, val:id}),
    storeProfile: data => dispatch(actionTypes.storeProfile(data))
  };
};
export default InspectorDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(InspectorDetails));



// WEBPACK FOOTER //
// ./src/Inspector/InspectorDetails.js